import fetch from 'auth/FetchInterceptor'
import {API_BASE_URL} from '../configs/AppConfig'
const GroupService = {}


GroupService.getGroup = function (params) {
	let {page, searchGroup} = params;
	let offset = (page-1)*10;
	
	return fetch({
		url: API_BASE_URL+'/v1/admin/all-group',
		method: 'get',
        params: {
            'offset' : offset,
			searchGroup
        }
	})
}; 

GroupService.getGroupWithId = function (id) {
	return fetch({
		url: API_BASE_URL+`/v1/admin/single-group/${id}`,
		method: 'get',

	})
};

GroupService.getGroupNote = function (data) {
	let {id, page} = data;

   let offset = (page-1)*10;
  return fetch({
	  url: API_BASE_URL+`/v1/admin/group-note/${id}`,
	  method: 'get',
	  params: {
		  'offset' : offset
	  }
  })
};

GroupService.getGroupPlayer = function (data) {
	let {id, page} = data;

   let offset = (page-1)*10;
  return fetch({
	  url: API_BASE_URL+`/v1/admin/group-player/${id}`,
	  method: 'get',
	  params: {
		  'offset' : offset
	  }
  })
};

GroupService.getGroupSession = function (data) {
	let {id, page} = data;

   let offset = (page-1)*10;
  return fetch({
	  url: API_BASE_URL+`/v1/admin/group-session/${id}`,
	  method: 'get',
	  params: {
		  'offset' : offset
	  }
  })
};

GroupService.createGroup = function (data) {
	return fetch({
		url: API_BASE_URL+`/v1/admin/create-new-group`,
		method: 'post',
        data: data

	})
};

GroupService.getAllCoach = function (data) {

  return fetch({
	  url: API_BASE_URL+`/v1/admin/get-all-club-coach`,
	  method: 'get',
	  params: {
		'club_id':data
	  }
	  
  })
};

GroupService.getAllClub = function (data) {
	
	return fetch({
		url: API_BASE_URL+`/v1/admin/get-all-club`,
		method: 'get',
		
	})
  };

  GroupService.updateGroup = function (data) {
	return fetch({
		url: API_BASE_URL+`/v1/admin/edit-group`,
		method: 'post',
        data: data
	})
};

GroupService.reActivateGroup = function (data) {
	return fetch({
		url: API_BASE_URL+`/v1/admin/re-activate-group`,
		method: 'post',
        data: data
	})
};


export default GroupService;